module.exports = __webpack_public_path__ + "img/tag-search-011.027c5632.png";